module.exports = __webpack_public_path__ + "static/media/Food Processing Entreprise (CMN) - Mobile - 24-06-2024 N .dfbc3a87.gif";